import { ApiError } from '@/domains/general/api/apiError';

/** Gewone-taalmelding voor de VAlert in de modal; de modal blijft open met de invoer. */
export function saveErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.status === 400) {
    return 'De indeling kon niet worden opgeslagen: een of meer criteria bestaan niet (meer). Controleer de blokken en probeer opnieuw.';
  }
  if (error instanceof ApiError && error.status === 403) {
    return 'Je hebt geen rechten om de Overview te bewerken.';
  }
  return 'Opslaan is mislukt. Probeer het opnieuw.';
}
